import { render, staticRenderFns } from "./HorarioListaAgrupada.vue?vue&type=template&id=ca215652"
import script from "./HorarioListaAgrupada.vue?vue&type=script&lang=js"
export * from "./HorarioListaAgrupada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports